<template>
  <rabbey-top-menu />
</template>

<script>
export default {};
</script>

<style></style>
